import { axiosInstance } from "./axios";
import { queryOptions } from "@tanstack/react-query";

export interface NotificationFeedItemDto {
    id: number;
    type: string;
    title: string;
    body: string;
    payload: string | null;
    isRead: boolean;
    createdAt: string;
}

export interface NotificationSettingsDto {
    followedPlayerMatchEmailEnabled: boolean;
    matchSummaryEmailEnabled: boolean;
    notificationEmail: string | null;
}

const QUERY_KEY = ["notification-settings"];

export const notificationSettingsApi = {
    getQueryOptions: () =>
        queryOptions({
            queryKey: QUERY_KEY,
            queryFn: async (): Promise<NotificationSettingsDto> => {
                const response = await axiosInstance.get<NotificationSettingsDto>(
                    "/notifications/settings"
                );
                return response.data;
            },
            staleTime: 5 * 60 * 1000,
        }),

    updateSettings: async (dto: NotificationSettingsDto): Promise<void> => {
        await axiosInstance.put("/notifications/settings", dto);
    },

    getFeedQueryOptions: () =>
        queryOptions({
            queryKey: ["notification-feed"],
            queryFn: async (): Promise<NotificationFeedItemDto[]> => {
                const response = await axiosInstance.get<NotificationFeedItemDto[]>(
                    "/notifications/feed"
                );
                return response.data;
            },
            staleTime: 2 * 60 * 1000,
        }),

    markRead: async (id: number): Promise<void> => {
        await axiosInstance.put(`/notifications/feed/${id}/read`);
    },

    markAllRead: async (): Promise<void> => {
        await axiosInstance.put("/notifications/feed/read-all");
    },
};
